export default {"src":"/_next/static/media/gdpr.ab1e49fb.svg","height":188,"width":302,"blurWidth":0,"blurHeight":0};